import React from "react";

class OfferIncentives extends React.Component {
  constructor(props){
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }
  onSubmit(e) {
    e.preventDefault();
    this.props.changeView('select_locations');
  }
  render() {
    return (
      <div className="main-container-loyalty">
        <h3 className="base-heading">SET YOUR LOYALTY PROGRAM</h3>
        <p className="sub-heading">Offer incentives to your customers</p>
        <div className="loyalty-menu-options-child">
          <img
            className="loyalty-menu-options-child-image"
            src="/amountSpent.svg"
          />
          <p className="loyalty-menu-heading">Earn points by Amount</p>
        </div>

        <div className="loyalty-menu-form">
          <form onSubmit={this.onSubmit}>
            <div className="loyalty-menu-form-field">
              <p>
                Offer points to customers in exchange for their phone number
              </p>
              <div className="loyalty-menu-form-custom-div">
                Points
                <input
                  type="number"
                  className="loyalty-form-input-field"
                  placeholder="0"
                />
              </div>
            </div>

            <div className="loyalty-menu-form-field">
              <p>
                Offer points to customers in exchange for connecting their
                Facebook profile
              </p>
              <div className="loyalty-menu-form-custom-div">
                Points
                <input
                  type="number"
                  className="loyalty-form-input-field"
                  placeholder="0"
                />
              </div>
            </div>

            <div className="loyalty-menu-form-field">
              <p>Expiry Date</p>
              <div className="loyalty-menu-form-custom-div">
                Points
                <input
                  type="number"
                  className="loyalty-form-input-field"
                  placeholder="0"
                />
              </div>
            </div>

            <div className="loyalty-menu-form-field">
              <p>Select your Notification reminders</p>
              <div className="loyalty-menu-form-notification-rem">
                <div className= "loyalty-menu-form-notification-opt">
                  <div>SMS</div>
                  <div>
                    <input type="checkbox" />
                  </div>
                </div>
                <div className= "loyalty-menu-form-notification-opt">
                  <div>Email</div>
                  <div>
                    <input type="checkbox" />
                  </div>
                </div>
              </div>
            </div>

            <div className="loyalty-menu-form-button-container">
              <button type="submit" className="loyalty-menu-form-button">
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default OfferIncentives;



// WEBPACK FOOTER //
// ./src/containers/LoyaltySetup/OfferIncentives.js